import { render, staticRenderFns } from "./testscore.vue?vue&type=template&id=40b0aa40&scoped=true"
import script from "./testscore.vue?vue&type=script&lang=js"
export * from "./testscore.vue?vue&type=script&lang=js"
import style0 from "./testscore.vue?vue&type=style&index=0&id=40b0aa40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b0aa40",
  null
  
)

export default component.exports